import { AfterViewInit, ChangeDetectorRef, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormGroup, FormBuilder, FormArray, FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import moment, { MomentInput } from 'moment';
import { MatDividerModule } from '@angular/material/divider';
import { MatDatepickerModule } from '@copo/mat-datepicker-new';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { NgIf, NgFor, NgClass, DecimalPipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MatIcon } from '@angular/material/icon';

import { UNDERSCORE } from '../../../../shared/utils/constant';
import { FastLaneWizardStep } from '../../../models/fastlane-wizard-state';
import { FormFastLane } from '../../../models/form-fastlane';
import { FastLaneWizardStepperService } from '../../../services/fastlane-wizard-stepper.service';
import { FastLaneWizardService } from '../../../services/fastlane-wizard.service';
import { FastLaneService } from '../../../services/fastlane.service';
import { currencyList, plant, rddTypes, transportMode, coilList, FORM_SHEET, FORM_BLANK, FORM_COIL,
	FORM_SLITTING_COIL, SHIP_TO_CUSTOM, SHIP_TO_BOC, units, formValues, SHIP_TO_LATER }
	from '../../../models/fastlane-list';
import { TranslationService } from '../../../../shared/services/translation.service';
import { WizardPageContent } from '../wizard-page-content';
import { WEEKYEAR_FORMAT_PATTERN } from '../../../../shared/models/filter-formats';
import { DATETIME_FORMAT_PATTERN, FastLaneItem, FastLaneRequestItem,
	FastLaneRequestAttachmentSubmit, FastLaneRequestAttachmentForm,
	FastLaneRequestAttachment } from '../../../models/fastlane.model';
import { SafeUrlPipe } from '../../../../shared/pipes/safeurl.pipe';

@Component({
	selector: 'copo-step-summary',
	templateUrl: './step-summary.component.html',
	styleUrl: './step-summary.component.css',
	encapsulation: ViewEncapsulation.Emulated,
	imports: [
		TranslateModule,
		NgIf,

		MatFormFieldModule,

		MatInputModule,
		FormsModule,
		ReactiveFormsModule,
		NgFor,
		NgClass,
		MatExpansionModule,
		MatDatepickerModule,
		MatDividerModule,
		DecimalPipe,
		SafeUrlPipe,
		MatIcon
	],
})

export class StepSummaryComponent extends WizardPageContent implements OnInit, AfterViewInit {
	readonly form: FormFastLane;
	productFormGroup!: FormGroup;
	readonly UNDERSCORE = UNDERSCORE;
	soldto?: string;
	description?: string | undefined;
	shipto = '';
	isCustomDestination = false;
	currency?: string;
	requestName?: string | undefined;
	descriptionRowSize = 6;
	private readonly VIEW_STEP_NUM = 3;
	constructor(
		public fb: FormBuilder,
		private readonly fastlaneWizardService: FastLaneWizardService,
		private readonly fastlaneStepperService: FastLaneWizardStepperService,
		private readonly fastlaneService: FastLaneService,
		private readonly translationService: TranslationService,
		public changeDetectorRef: ChangeDetectorRef
	) {
		super(FastLaneWizardStep.SUMMARY, fastlaneWizardService.getState());
		this.form = this.fastlaneWizardService.getStateFastLaneForm();
		this.initializeProductSpecifications();
		this.createSubmitReqObj(this.productFormGroup);
	}

	get productResultControl() {
		return (<FormArray> this.productFormGroup.controls['productSpecifications']).controls;
	}

	get productFormArray() {
		return <FormArray> this.productFormGroup.get('productSpecifications');
	}

	getCoilAxis(formIndex: number) {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		const fieldControl = <FormControl>controlArray.controls[formIndex].get('coilAxis');
		const coilAxisValue = <string>fieldControl.value;
		for (const coil of coilList) {
			if (coilAxisValue === coil.value) {
				return coil.display;
			}
		}
		return ' ';
	}

	getAdditionalInfoRowSize(formIndex: number) {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		const fieldControl = <FormControl>controlArray.controls[formIndex].get('additionalItemInfo');
		const fieldvalue = <string>fieldControl.value;
		const lines = fieldvalue.split('\n');
		if (lines.length > 6) {
			return lines.length;
		}
		return 6;
	}

	getRddType(formIndex: number) {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		const fieldControl = <FormControl>controlArray.controls[formIndex].get('rddType');
		const rddTypeValue = <string>fieldControl.value;
		for (const rddType of rddTypes) {
			if (rddTypeValue === rddType.code) {
				return rddType.value;
			}
		}
		return ' ';
	}

	getRdd(formIndex: number) {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		const fieldControl = <FormControl>controlArray.controls[formIndex].get('rddDate');
		const rddType = this.getRddType(formIndex);
		let formattedDate = null;
		if (fieldControl.value && fieldControl.value !== null && fieldControl.value !== 'undefined') {
			const dateValue: MomentInput = <MomentInput>fieldControl.value;
			formattedDate = rddType === 'Week' ? moment(dateValue).format(WEEKYEAR_FORMAT_PATTERN)
				: moment(dateValue).format('DD/MM/YYYY');
		}
		return formattedDate;
	}

	getTransportMode(formIndex: number) {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		const fieldControl = <FormControl>controlArray.controls[formIndex].get('transportMode');
		const transportModeValue = <string>fieldControl.value;
		for (const transportModeObj of transportMode) {
			if (transportModeValue === transportModeObj.value) {
				return transportModeObj.display;
			}
		}
		return transportModeValue === 'None' ? '-- None --' : transportModeValue;
	}

	getTextFieldValueByControl(formIndex: number, contolName: string) {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		const fieldControl = <FormControl>controlArray.controls[formIndex].get(contolName);
		let fieldvalue = fieldControl.value === null ? '' : <string> fieldControl.value;
		if (fieldvalue.length > 20) {
			const textArray = fieldvalue.match(/.{1,20}/g);
			fieldvalue = textArray ? textArray.join('\n') : fieldvalue;
		}
		return fieldvalue;
	}

	getSelectedShipByIndex(formIndex: number) {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		const fieldControl = <FormControl>controlArray.controls[formIndex].get('shipTo');
		let selShiptoId = <string>fieldControl.value;
		const shipToList = this.fastlaneService.filterShiptoList;
		if (selShiptoId === SHIP_TO_CUSTOM) {
			selShiptoId = this.translationService.getTR('fastlane.wizard.custom.destination');
		} else if (selShiptoId === SHIP_TO_LATER) {
			selShiptoId = this.translationService.getTR('fastlane.wizard.decide.later');
		} else if (shipToList) {
			for (const shipTo of shipToList) {
				if (shipTo.businessId === selShiptoId) {
					selShiptoId = `${ shipTo.name } - ${ shipTo.city }`;
				}
			}
		}
		if (shipToList) {
			for (const shipTo of shipToList) {
				if (shipTo.businessId === selShiptoId) {
					selShiptoId = `${ shipTo.name } / ${ shipTo.city }`;
				}
			}
		}
		if (selShiptoId.length > 20) {
			const textArray = selShiptoId.match(/.{1,20}/g);
			selShiptoId = textArray ? textArray.join('\n') : selShiptoId;
		}
		return selShiptoId;
	}

	getDesiredamlplant(formIndex: number) {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		const fieldControl = <FormControl>controlArray.controls[formIndex].get('plant');
		const desiredamlplantValue = <string>fieldControl.value;
		for (const plantObj of plant) {
			if (desiredamlplantValue === plantObj.code) {
				return plantObj.code.concat(' ').concat(plantObj.value);
			}
		}
		return ' ';
	}

	getIncoterms(formIndex: number) {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		const fieldControl = <FormControl>controlArray.controls[formIndex].get('incoterms');
		const fieldvalue = <string>fieldControl.value;
		return fieldvalue === 'None' ? '-- None --' : fieldvalue;
	}

	getUnit(formIndex: number) {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		const fieldControl = <FormControl>controlArray.controls[formIndex].get('quantityUnit');
		return this.translationService.getTR(this.getTranslationKey(<string>fieldControl.value, units));
	}

	getTranslationKey(code: string, arr: { value: string; display: string }[]) {
		const translationObj = arr.find(item => item.value === code);
		return translationObj ? translationObj.display : '';
	}

	initializeProductSpecifications() {
		if (this.fastlaneService.productFormGroup) {
			this.productFormGroup = this.fastlaneService.productFormGroup;
		} else {
			this.productFormGroup = new FormGroup({
				productSpecifications: new FormArray([]),
			});
			this.fastlaneService.productFormGroup = this.productFormGroup;
		}
	}

	ngOnInit(): void {
		const soldtoShiptoList = this.fastlaneService.filteredSoldtoShiptoList;
		const selSoldtoId = <string> this.form.getFormSoldTo().value;
		const selShiptoId = <string> this.form.getFormShipTo().value;
		this.description = <string> this.form.getFormDescription().value;
		if (this.description) {
			const descriptionLines = this.description.split('\n');
			this.descriptionRowSize = Math.max(descriptionLines.length, 6);
		}
		this.requestName = <string> this.form.getFormCustomerRequestName().value;

		const shipToList = this.fastlaneService.filterShiptoList;
		if (selShiptoId === SHIP_TO_CUSTOM) {
			this.isCustomDestination = true;
			this.shipto = this.translationService.getTR('fastlane.wizard.custom.destination');
		} else if (selShiptoId === SHIP_TO_LATER) {
			this.shipto = this.translationService.getTR('fastlane.wizard.decide.later');
		} else if (shipToList) {
			for (const shipTo of shipToList) {
				if (shipTo.businessId === selShiptoId) {
					this.shipto = `${ shipTo.name } - ${ shipTo.city }`;
				}
			}
		}
		if (shipToList) {
			for (const shipTo of shipToList) {
				if (shipTo.businessId === selShiptoId) {
					this.shipto = `${ shipTo.name } / ${ shipTo.city }`;
				}
			}
		}
		if (soldtoShiptoList) {
			const selectedSoldtoList = soldtoShiptoList.filter(v => v.businessId === selSoldtoId);
			for (const soldtoList of selectedSoldtoList) {
				this.soldto = `${ soldtoList.name } - ${ soldtoList.city }`;
			}
		}
		this.fastlaneStepperService.onStepChanged.emit({ step: this.VIEW_STEP_NUM });
		const currencyCode = <string> this.form.getFormCurrency().value;
		const currencyCodeValue = currencyList.find(x => x.code === currencyCode);
		if (currencyCodeValue) {
			this.currency = `${ currencyCodeValue.code }  -  ${ currencyCodeValue.description }`;
		}
	}

	ngAfterViewInit() {
		this.changeDetectorRef.detectChanges();
	}

	checkError(): boolean {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		for (const control of controlArray.controls) {
			if (control.invalid) {
				return true;
			}
		}
		return false;
	}

	geterror(formIndex: number, controlName: string) {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		const fieldControl = <FormControl>controlArray.controls[formIndex].get(controlName);

		return Boolean(fieldControl.errors?.['required'] && fieldControl.touched);
	}

	getPlant() {
		return plant;
	}

	isSelectedAndNotFormBlanks(formIndex: number) {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		const fieldControl = <FormControl>controlArray.controls[formIndex].get('form');
		return Boolean(fieldControl.value && fieldControl.value !== FORM_BLANK);
	}

	isFormBlankSelected(formIndex: number) {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		const fieldControl = <FormControl>controlArray.controls[formIndex].get('form');
		return fieldControl.value === FORM_BLANK;
	}

	isSheetSelected(formIndex: number) {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		const fieldControl = <FormControl>controlArray.controls[formIndex].get('form');
		return fieldControl.value === FORM_SHEET;
	}

	isCoilOrSlittingCoilSelected(formIndex: number) {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		const fieldControl = <FormControl>controlArray.controls[formIndex].get('form');
		return Boolean(fieldControl.value === FORM_COIL || fieldControl.value === FORM_SLITTING_COIL);
	}

	getValueByControlName(formIndex: number, controlName: string) {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		const fieldControl = <FormControl>controlArray.controls[formIndex].get(controlName);
		return <string>fieldControl.value;
	}

	getOrderTrackingForm(formIndex: number, controlName: string) {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		const fieldControl = <FormControl>controlArray.controls[formIndex].get(controlName);
		return this.translationService.getTR(this.getTranslationKey(<string>fieldControl.value, formValues));
	}

	getRequestNameDescriptionText(requestName: string) {
		if (requestName && requestName.length > 40) {
			const textArray = requestName.match(/.{1,40}/g);
			return textArray ? textArray.join('\n') : requestName;
		}
		return requestName;
	}

	getDescriptionText(inputValue: string) {
		if (inputValue && inputValue.length > 35) {
			const textArray = inputValue.match(/.{1,35}/g);
			return textArray ? textArray.join('\n') : inputValue;
		}
		return inputValue;
	}

	getAttachments(formIndex: number) {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		const attachmentFormGroups = <FormArray> controlArray.controls[formIndex].get('fastLaneRequestItemAttachments');
		const attachments: FastLaneRequestAttachment[] = [];
		for (const itemRow of attachmentFormGroups.value) {
			const fastLaneAttachment = (<FastLaneRequestAttachmentForm>
				itemRow).fastlaneAttachment;
			attachments.push(fastLaneAttachment);
		}
		return attachments;
	}

	getRequestAttachments() {
		const attachmentFormGroups = <FormArray> this.form.get('fastLaneAttachments');
		const attachments: FastLaneRequestAttachment[] = [];
		for (const itemRow of attachmentFormGroups.value) {
			const fastLaneAttachment = (<FastLaneRequestAttachmentForm>
				itemRow).fastlaneAttachment;
			attachments.push(fastLaneAttachment);
		}
		return attachments;
	}

	hasAttachments(formIndex: number) {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		const attachmentFormGroups = <FormArray> controlArray.controls[formIndex].get('fastLaneRequestItemAttachments');
		return attachmentFormGroups.length > 0;
	}

	hasRequestAttachments() {
		const attachmentFormGroups = <FormArray> this.form.get('fastLaneAttachments');
		return attachmentFormGroups.length > 0;
	}

	createSubmitReqObj(pdtGroup: FormGroup) {
		const requestOrderItemList: FastLaneItem[] = [];
		const controlArray = <FormArray>pdtGroup.get('productSpecifications');
		const soldTo = String(this.form.getFormSoldTo().value).padStart(10, '0');
		let shipTo = null;
		let shipToType;
		let shipToCustom = null;
		let shipToPerson = null;
		let shipToContact = null;
		if (this.form.getFormShipTo().value === SHIP_TO_CUSTOM) {
			shipToType = SHIP_TO_CUSTOM;
			shipToCustom = String(this.form.getFormShipToCustom().value);
			shipToPerson = String(this.form.getFormShipToPerson().value);
			shipToContact = String(this.form.getFormShipToContact().value);
		} else if (this.form.getFormShipTo().value === SHIP_TO_LATER) {
			shipToType = SHIP_TO_LATER;
		} else {
			shipTo = String(this.form.getFormShipTo().value).padStart(10, '0');
			shipToType = SHIP_TO_BOC;
		}
		let description = '';
		if (this.form.getFormDescription().value !== undefined) {
			description = String(this.form.getFormDescription().value);
		}
		let fastLaneRequestAttachments;
		const fastLaneRequestAttachment: FastLaneRequestAttachmentSubmit[] = [];
		if (this.form.getFastLaneRequestAttachments().value !== null || this.form.getFastLaneRequestAttachments().value
			!== undefined) {
			fastLaneRequestAttachments = this.form.getFastLaneRequestAttachments();
			for (const itemRow of fastLaneRequestAttachments.value) {
				const fastLaneAttachment = (<FastLaneRequestAttachmentForm>
					itemRow).fastlaneAttachment;
				const attachment: FastLaneRequestAttachmentSubmit =
				{
					fileName: fastLaneAttachment.fileName,
					type: fastLaneAttachment.type,
					fileSize: fastLaneAttachment.fileSize,
					hash: fastLaneAttachment.hash
				};
				fastLaneRequestAttachment.push(attachment);
			}
		}
		for (const [index, control] of controlArray.controls.entries()) {
			const pdt = <FastLaneRequestItem>control.value;
			let shipToItem = null;
			let shipToTypeItem;
			let shipToCustomItem = null;
			let shipToPersonItem = null;
			let shipToContactItem = null;
			if (pdt.shipTo === SHIP_TO_CUSTOM) {
				shipToTypeItem = SHIP_TO_CUSTOM;
				shipToCustomItem = String(pdt.shipToCustom);
				shipToPersonItem = String(pdt.shipToPerson);
				shipToContactItem = String(pdt.shipToContact);
			} else if (pdt.shipTo === SHIP_TO_LATER) {
				shipToTypeItem = SHIP_TO_LATER;
			} else {
				shipToItem = String(pdt.shipTo).padStart(10, '0');
				shipToTypeItem = SHIP_TO_BOC;
			}
			const dateValue: MomentInput = <MomentInput>pdt.rddDate;
			let formattedDateWeek = '';
			let formatedDeliveryDate = '';
			if (dateValue !== null && dateValue !== 'undefined') {
				formattedDateWeek = String(moment(dateValue).format(WEEKYEAR_FORMAT_PATTERN));
				formatedDeliveryDate = moment(dateValue).format(DATETIME_FORMAT_PATTERN);
			}
			const attachmentFormGroups = <FormArray> control.get('fastLaneRequestItemAttachments');
			const fastlaneRequestItemAttachments: FastLaneRequestAttachmentSubmit[] = [];
			for (const itemRow of attachmentFormGroups.value) {
				const fastLaneAttachment = (<FastLaneRequestAttachmentForm>
					itemRow).fastlaneAttachment;
				const attachment: FastLaneRequestAttachmentSubmit =
				{
					fileName: fastLaneAttachment.fileName,
					type: fastLaneAttachment.type,
					fileSize: fastLaneAttachment.fileSize,
					hash: fastLaneAttachment.hash
				};
				fastlaneRequestItemAttachments.push(attachment);
			}

			const requestOrderItem: FastLaneItem =
			{
				itemNumber: (index + 1).toString().padStart(3, '0'),
				name: pdt.name,
				steelgrade: pdt.steelgrade,
				form: pdt.form,
				thickness: pdt.thickness,
				width: pdt.width,
				length: pdt.length,
				sheetWeightKg: pdt.sheetWeightKg,
				quantity: pdt.quantity,
				blankWeight: pdt.blankWeight,
				coating: pdt.coating,
				coilAxis: pdt.coilAxis,
				oiling: pdt.oiling,
				innerDiameter: pdt.innerDiameter,
				maxOutsideDiameter: pdt.maxOutsideDiameter,
				additionalItemInfo: pdt.additionalItemInfo,
				rddType: pdt.rddType,
				rddDate: formatedDeliveryDate,
				rddDisplay: formattedDateWeek,
				transportMode: pdt.transportMode,
				incoterms: pdt.incoterms === 'None' ? '' : pdt.incoterms,
				packing: pdt.packing,
				plant: pdt.plant === ' ' ? 'None' : pdt.plant,
				quantityUnit: pdt.quantityUnit,
				totalWeight: pdt.totalWeight,
				shipTo: shipToItem,
				shipToType: shipToTypeItem,
				shipToCustom: shipToCustomItem,
				shipToPerson: shipToPersonItem,
				shipToContact: shipToContactItem,
				fastLaneRequestItemAttachments: fastlaneRequestItemAttachments
			};
			requestOrderItemList.push(requestOrderItem);
		}
		this.fastlaneService.requestOrderObj = {
			requestName: String(this.form.getFormCustomerRequestName().value),
			soldTo,
			shipTo,
			shipToType,
			shipToCustom,
			shipToPerson,
			shipToContact,
			description,
			fastLaneRequestAttachment,
			currency: String(this.form.getFormCurrency().value),
			fastLaneItems: requestOrderItemList
		};
	}
}
